import React from "react";

import Accordion from "./accordion";

const GeneralAccordionSetWrapper = ({
  list,
  currentSlide,
  setCurrentSlide = () => {},
  accordionIdentifier = "id",
  containerClass = "flex flex-col w-full py-3 tab-content",
  controlClassName = "flex px-3 py-5 rounded-sm bg-green-light",
  textClassName = "text-white uppercase font-bold tracking-wide",
  contentClassName = "px-3 py-6 mb-3 bg-white",
  ...props
}) => {
  return (
    <>
      {list &&
        list?.length > 0 &&
        list?.map((accordion, idx) => {
          const accordionTag = accordion[accordionIdentifier] || idx;
          const isExpanded = currentSlide === accordionTag;
          const accordionRef = accordion?.ref;
          return (
            <>
              <div
                className={containerClass}
                id={accordionTag}
                ref={accordionRef}
              >
                <Accordion
                  key={`accordion-set-${idx}-${accordion?.id || idx}`}
                  title={accordion?.title}
                  controlClassName={controlClassName}
                  textClassName={textClassName}
                  content={accordion?.comp}
                  contentClassName={contentClassName}
                  isCollapse={isExpanded}
                  tapClick={() => setCurrentSlide(accordionTag, accordionRef)}
                  extraContentHeaderClass={
                    accordion?.extraContentHeaderClass || ""
                  }
                  extraContentHeader={accordion?.extraContentHeader || <></>}
                  {...props}
                />
              </div>
            </>
          );
        })}

      <></>
    </>
  );
};

export default GeneralAccordionSetWrapper;
